<!-- 教学数据展板 -->
<template>
    <div>
        <div class="panorama-data-board">
            <div class="panorama-data-board-left">
                <!-- 学校活跃排行榜 -->
                <school-active-rank></school-active-rank>
                <!-- 综评排行榜 -->
                <comprehensive-rank></comprehensive-rank>

            </div>
            <div class="panorama-data-board-content">
                <region-number-info :tab="'teaching'"></region-number-info>
                <!-- 地图及旋转 -->
                <dynamics-region-map></dynamics-region-map>
            </div>
            <div class="panorama-data-board-right">
                <!-- 学科资源分析 -->
                <subject-resource-analysis></subject-resource-analysis>
                <!-- 年级评价分析 -->
                <assessment-analysis></assessment-analysis>
            </div>
        </div>
        <div class="panorama-data-board">
            <!-- 教学数据展板底部 -->
            <div class="panorama-data-board-left">
                <!-- 教学行为分析 -->
                <teach-behavior-analysis></teach-behavior-analysis>
            </div>
            <div style="width:calc(37.5% - 20px) ;">
                <subject-application-analysis></subject-application-analysis>
            </div>
            <div style="width:calc(37.5% - 20px) ;">
                <homework-analysis></homework-analysis>
            </div>
        </div>
    </div>
</template>
<script>
import schoolActiveRank from "@/views/site/modules/schoolActiveRank.vue"
import teachBehaviorAnalysis from "@/views/site/modules/teachBehaviorAnalysis.vue"
import comprehensiveRank from "@/views/site/modules/comprehensiveRank.vue"
import subjectResourceAnalysis from "@/views/site/modules/subjectResourceAnalysis.vue"
import assessmentAnalysis from "@/views/site/modules/assessmentAnalysis.vue"
import RegionNumberInfo from "@/views/site/modules/RegionNumberInfo.vue"
import dynamicsRegionMap from "@/views/site/modules/dynamicsRegionMap.vue"
import subjectApplicationAnalysis from "@/views/site/modules/subjectApplicationAnalysis.vue"
import homeworkAnalysis from "@/views/site/modules/homeworkAnalysis.vue"

export default {
    name: 'teaching',
    components: {
        schoolActiveRank,
        teachBehaviorAnalysis,
        comprehensiveRank,
        subjectResourceAnalysis,
        assessmentAnalysis,
        RegionNumberInfo,
        dynamicsRegionMap,
        subjectApplicationAnalysis,
        homeworkAnalysis,
    },
    data() {
        return {
        }
    },
    methods: {

    },
    watch: {

    },
    computed: {

    },
    mounted() {
    },
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: DigifaceWide;
    src: url('../../../assets/fonts/DigifaceWide Regular.ttf'); //字体路径
}

.panorama-data-board {
    display: flex;
    // align-items: center;
    justify-content: space-between;
    width: 100%;

    .panorama-data-board-left {
        width: calc(25% - 10px);
    }

    .panorama-data-board-content {
        width: calc(50% - 20px);
    }

    .panorama-data-board-right {
        width: calc(25% - 10px);
    }
}
</style>